module.exports = __webpack_public_path__ + "static/media/ccTomas.a2ab223c.svg";